import { NgModule } from '@angular/core';
import { NbCardModule, NbIconModule, NbInputModule, NbToggleModule, NbActionsModule, NbSpinnerModule } from '@nebular/theme';
import { Ng2SmartTableModule } from 'ng2-smart-table';

import { ThemeModule } from '../../@theme/theme.module';
import { routedComponents, SouscriptionsRoutingModule } from './souscriptions-routing.module';
import { FormsModule } from '@angular/forms';
import { NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ShowSouscriptionComponent } from './show-souscription/show-souscription.component';


@NgModule({
  imports: [
    NbCardModule,
    NbIconModule,
    NbInputModule,
    ThemeModule,
    SouscriptionsRoutingModule,
    Ng2SmartTableModule,
    FormsModule,
    NbToggleModule,
    NgbModule,
    NgMultiSelectDropDownModule, 
    NbActionsModule,
    NbSpinnerModule,
  ],
  entryComponents: [
    ShowSouscriptionComponent,
  ],
  declarations: [
    ShowSouscriptionComponent,
    ...routedComponents,
  ],
})
export class SouscriptionsModule { }
